import Button from "@mui/material/Button";
import React, { useEffect, useMemo, useRef, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "./AppBar";
import { Trans } from "react-i18next";
import ToolbarContainer from "./ToolbarContainer";
import ActionsContainer from "./ActionsContainer";
import TemplateContainer from "./TemplateContainer";
import ExitDialog from "./ExitDialog";
import { Skeleton } from "@mui/material";
import { callAPI } from "../../../../../lib/common";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
  ACTIONS,
  createInstance,
} from "../../../../../Providers/TemplateInstanceProvider";
import DrawTemplate from "../../../../../components/Template/DrawTemplate";
import { getBoxSize } from "../../../../../utils";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  toolBarContainer: {
    width: "100%",
    overflowX: "auto",
    flexGrow: 1,
    display: "flex",
  },

  toolbarItems: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    marginBottom: theme.spacing(2),
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    "& > li": {
      flex: "0 0 auto",
      textAlign: "center",
      marginLeft: theme.spacing(2),
      border: `2px solid transparent`,
    },
    "& > li$selectedTemplate": {
      border: `2px solid ${theme.palette.secondary.main}`,
    },
    "& h6": {
      whiteSpace: "nowrap",
    },
  },

  rightMenuSpacer: {
    width: theme.spacing(1),
  },
  selectedTemplate: {},
}));

export default ({ changeMenu }) => {
  const classes = useStyles();
  const [showSaveChangesDialog, setShowSaveChangesDialog] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [templates, setTemplates] = useState(null);
  const [state, dispatch] = useTemplateInstance();
  const originalInstance = useRef(state);

  useEffect(() => {
    const { product } = state;
    console.log("The product is", state);
    callAPI("/api/webshop/user/templates/by-product/" + product.uuid).then(
      (templates) => {
        setTemplates(templates);
      },
    );
  }, []);

  const handleChangeTemplate = (templateItem) => {
    let instance = createInstance(
      templateItem.template,
      templateItem.userResources,
      originalInstance.current.year,
    );
    instance.clientCompatibilityDate = templateItem.clientCompatibilityDate;

    instance.partOfPackage = originalInstance.current.partOfPackage;

    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: instance,
    });

    dispatch({
      type: ACTIONS.SET_PRODUCT,
      product: originalInstance.current.product,
    });
    setDirty(true);
  };

  const handleCancel = (e) => {
    e.stopPropagation();

    if (dirty) {
      setShowSaveChangesDialog(true);
    } else {
      //setLocalResource(null);
      setTimeout(() => {
        doClose();
      }, 300);
    }
  };

  const doClose = () => {
    dispatch({
      type: ACTIONS.SET_TEMPLATE_INSTANCE,
      templateInstance: originalInstance.current,
    });
    changeMenu("main");
  };

  return (
    <div className={classes.mainContainer}>
      <AppBar onCancel={handleCancel} />

      <TemplateContainer />

      <ToolbarContainer>
        <div className={classes.toolBarContainer}>
          <ul className={classes.toolbarItems}>
            {!templates && <Skeletons />}
            {templates && (
              <TemplateList
                templates={templates}
                handleChangeTemplate={handleChangeTemplate}
              />
            )}
          </ul>
        </div>
        <ActionsContainer>
          <Button color="primary" onClick={handleCancel}>
            <Trans>Cancel</Trans>
          </Button>
          <Button color="primary" onClick={() => changeMenu("main")}>
            <Trans>Done</Trans>
          </Button>
        </ActionsContainer>
      </ToolbarContainer>
      <ExitDialog
        open={showSaveChangesDialog}
        handleCancel={() => setShowSaveChangesDialog(false)}
        handleOk={doClose}
      />
    </div>
  );
};

const Skeletons = () => {
  const objects = Array.from(Array(6).keys());
  return (
    <>
      {objects.map((num) => (
        <li key={num}>
          <Skeleton variant="rectangular" width={80} height={120} />
        </li>
      ))}
    </>
  );
};

const TemplateList = ({ templates, handleChangeTemplate }) => {
  const classes = useStyles();
  const [templateInstance] = useTemplateInstance();

  console.log("The state is", templateInstance);
  return (
    <>
      {templates.map((templateItem) => {
        console.log("Compare uuid", templateInstance.template, templateItem);
        return (
          <li
            key={templateItem.template.uuid}
            onClick={() => handleChangeTemplate(templateItem)}
            className={
              templateInstance.template.uuid === templateItem.template.uuid
                ? classes.selectedTemplate
                : ""
            }
          >
            <TemplatePreview
              templateItem={templateItem}
              year={templateItem.year}
              clientCompatibilityDate={templateItem.clientCompatibilityDate}
            />
          </li>
        );
      })}
    </>
  );
};

const TemplatePreview = ({ templateItem }) => {
  const size = { width: 120, height: 120 };

  const [cSize, style] = useMemo(() => {
    const cSize = getBoxSize("fit-in", templateItem.template.dimensions, {
      width: size.width,
      height: size.height,
    });

    const style = {
      width: cSize.width + "px",
      height: cSize.height + "px",
      position: "relative",
      boxShadow: "0px 3px 6px #00000029",
    };
    return [cSize, style];
  }, [size]);

  const templateInstance = useMemo(() => {
    const instance = createInstance(
      templateItem.template,
      templateItem.userResources,
    );
    instance.clientCompatibilityDate = templateItem.clientCompatibilityDate;
    return instance;
  }, [templateItem]);

  console.log("The template size is ", cSize);

  return (
    <div>
      <div style={style}>
        <DrawTemplate
          templateInstance={templateInstance}
          containerSize={cSize}
        />
      </div>
      {/*<div>
            {templateItem.name}
        </div>*/}
    </div>
  );
};
